import {CheckoutInfo, Subscription, SubscriptionPlan} from "@/types/UserType";
import {ResponseError} from "@/types";
import {client} from "@/data/axios";
import {resolveError} from "@/data/_resolveError";

export const subscription = (
    success = (subscription: Subscription) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/subscription`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const plans = (
    success = (plans: SubscriptionPlan[]) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/subscription/available`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const checkoutInfo = (
    subscriptionKey: string,
    promo: string|null = null,
    period: number = 1,
    success = (data: CheckoutInfo) => {},
    failed = (type: ResponseError, data: any) => {},
    isBlackFridayUpgrade: boolean = false
) => {
    const params = new URLSearchParams({
        key: subscriptionKey,
        promo: promo || '',
        period: period.toString(),
    });
    
    if (isBlackFridayUpgrade) {
        params.append('is_black_friday_upgrade', 'true');
    }
    
    client.get(`/checkout?${params.toString()}`)
        .then(({data}) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const checkout = (
    subscriptionKey: string,
    promo: string|null = null,
    card: string|null,
    period: number = 1,
    isBlackFridayUpgrade: boolean = false,
    success = (data: {token_payment: boolean, redirect_to: string|null}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/checkout`, {
        key: subscriptionKey,
        promo: promo ? promo : null,
        card: card,
        period: period,
        is_black_friday_upgrade: isBlackFridayUpgrade,
    }).then(({data}) => {
        success(data.data);
    }).catch((error) => resolveError(error, failed));
}

export const disableRenew = (
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/subscription/renew/disable`).then(({data}) => {
        success();
    }).catch((error) => resolveError(error, failed));
}

export const enableRenew = (
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/subscription/renew/enable`).then(({data}) => {
        success();
    }).catch((error) => resolveError(error, failed));
}

export const checkBlackFridayUpgrade = (
    success = (data: {is_active: boolean, can_upgrade: boolean, available_upgrades: Array<{plan_key: string, plan: any, old_plan: any, bonus_days: number, discount_percent: number}>}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/subscription/black-friday-upgrade`)
        .then(({data}) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}